const IconBurger = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M0.125 0.84375C0.125 0.386719 0.476562 0 0.96875 0H15.0312C15.4883 0 15.875 0.386719 15.875 0.84375C15.875 1.33594 15.4883 1.6875 15.0312 1.6875H0.96875C0.476562 1.6875 0.125 1.33594 0.125 0.84375ZM0.125 6.46875C0.125 6.01172 0.476562 5.625 0.96875 5.625H15.0312C15.4883 5.625 15.875 6.01172 15.875 6.46875C15.875 6.96094 15.4883 7.3125 15.0312 7.3125H0.96875C0.476562 7.3125 0.125 6.96094 0.125 6.46875ZM15.0312 12.9375H0.96875C0.476562 12.9375 0.125 12.5859 0.125 12.0938C0.125 11.6367 0.476562 11.25 0.96875 11.25H15.0312C15.4883 11.25 15.875 11.6367 15.875 12.0938C15.875 12.5859 15.4883 12.9375 15.0312 12.9375Z"
            fill={color}
        />
    </svg>
);

export default IconBurger;
